<template>
    <Modal v-model="show"
           :mask-closable="false"
           :title="`${$t('调整带宽')}`">
        <Form ref="form"
              label-position="right"
              :model="fromData"
              :rules="validate"
              :label-width="100">
            <FormItem :label="`${$t('弹性IP')}:`">
                <!-- {{floatIp.ip}} -->
            </FormItem>
            <FormItem :label="`${$t('带宽')}:`"
                      prop="bandWidth">
                <div class="bandWidth-pack">
                    <InputNumber :min="1"
                                 :max="300"
                                 :step="1"
                                 class="bandWidth"
                                 v-model="fromData.bandWidth"></InputNumber>
                    <span class="unit">(Mbit/s)</span>
                </div>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text"
                    @click="closeModal">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="submit">
                <span>{{!loading ? $t('保存') : $t('保存中')}}</span>
            </Button>
        </div>
    </Modal>
</template>
<script>
import API from '@/service/api'
export default {
    name: 'adjustbandwidth',
    data () {
        return {
            fromData: {},
            show: false,
            loading: false,
            validate: {
                bandWidth: [
                    {
                        required: true,
                        trigger: 'change',
                        validator: (rule, value, callback) => {
                            if (value === '' || value === null) {
                                callback(this.$i18n.t('该字段不能为空'))
                            } else {
                                callback()
                            }
                        }
                    }
                ]
            }
        }
    },
    methods: {
        openModal (obj) {
            this.show = true
            const option = {
                id: obj.id,
                envId: obj.envId,
                uuid: obj.uuid,
                bandWidth: parseInt(obj.bandWidth)
            }
            this.fromData = option
        },
        closeModal () {
            this.$refs.form.resetFields()
            this.loading = false
            this.show = false
        },
        submit () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.axios.put(this.urlFormat(API.REVISE_BANDWIDTH, false), this.fromData).then(res => {
                        if (res) {
                            this.$emit('refresh')
                            this.closeModal()
                        } else {
                            this.loading = false
                        }
                    })
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.bandWidth-pack {
    display: flex;
    .bandWidth {
        width: 100%;
    }
    .unit {
        margin-left: 10px;
    }
}
</style>
